import { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks/useSelector'
import moment from 'moment'
import classNames from 'classnames'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { debounce, ErrorAlert, PageLoadingSpinner, Search, SvgIcon } from 'ui_kit_qmd'
import { EventLocations } from 'lib/segment/constants'
import errorIcon from '../../images/common/error-icon.svg'
import { VisitTableColumnTitles } from './visits-table-column-titles/VisitTableColumnTitles'
import { VisitTableColumnRows } from './visits-table-column-rows/VisitTableColumnRows'
import { clearVisitData, getRemarks, getVisits, setVisitError } from '../../store/visits/VisitsActions'
import { VisitsPageTools } from './VisitsPageTools/VisitsPageTools'
import { resetRemarksUpdated } from '../../store/patient-side-panel/PatientSidePanelActions'
import { VisitRemarks } from './visit-remarks/VisitRemarks'
import { RemarksIcon } from './remarks-icon'
import {
  PAST_VISIT,
  PATIENT_PAST_VISIT_PAGE_PATH,
  PATIENT_UPCOMING_VISIT_PAGE_PATH,
  tableViewOptions,
  UPCOMING_VISIT,
  VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY,
  VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY,
  VISITS_TAGS_FILTER_LOCAL_STORAGE_KEY,
} from '../../utils/constants'
import { initialState, reducer } from './VisitsReducer'
import './Visits.scss'
import { VisitsListener } from '../../store/visits/VisitsListener'
import { useSessionStorage } from '../../utils/hooks/useSessionStorage'
import { onHandleLinkToVisit } from './helper'
import { getTabId, parseTimeZone } from '../../utils/common'
import { windowOpenArgs } from 'utils/windowOpenArgs'
import { PageLayout } from 'components/page-layouts/PageLayout'

const COUNT_STEP = 9
const PAGINATION_INITIAL = [0, COUNT_STEP, false]

const errorAlertStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  top: 0,
  zIndex: 9999,
  position: 'absolute',
  left: 0,
  right: 0,
}

const errorAlertContainerStyle = { width: 550 }
export const Visits = () => {
  const dispatch = useDispatch()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.visitsPage.error)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.visitsPage.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitTypesLoading = useSelector((state) => state.accountSettings.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visits = useSelector((state) => state.visitsPage.visits)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const remarks = useSelector((state) => state.visitsPage.remarks)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitRemarksIsUpdated = useSelector((state) => state.patientSidePanel.isUpdated)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitData = useSelector((state) => state.visitsPage.visitData)
  const [visitRemarks, setVisitRemarks] = useState({})
  const [openedRemarksVisitId, setOpenedRemarksVisitId] = useState(null)
  const [tableView, setTableView] = useState(tableViewOptions[0])
  const [currentDate, setCurrentDate] = useState(new Date())
  const [extraWidthClass, setExtraWidthClass] = useState(true)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [noTransition, setNoTransition] = useState(true)
  const [showRemarks, setShowRemarks] = useState(false)
  const [visitSearchValue, setVisitSearchValue] = useState('')
  const [visitTypesFilterRow, setVisitTypesFilterRow] = useState('')
  const [statusFilterRow, setStatusFilterRow] = useState('')
  const [tagFilterRow, setTagFilterRow] = useState('')
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const timeZone = parseTimeZone(profile.TimeZone)
  console.log('tagFilterRow', tagFilterRow)
  const [, , removeStoredSelectedVisitsList] = useSessionStorage(VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY, [])
  const [, , removeStoredSelectedStatusList] = useSessionStorage(VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY, [])
  const [, , removeStoredSelectedTagList] = useSessionStorage(VISITS_TAGS_FILTER_LOCAL_STORAGE_KEY, [])
  const [paginationState, setPaginationState] = useState(PAGINATION_INITIAL)
  const [stateFilter, dispatchFilter] = useReducer(reducer, initialState(timeZone))
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isNeedToResetRemarksInputError, setIsNeedToResetRemarksInputError] = useState(null)
  const [isNeedToUpdateVisitRemarks, setIsNeedToUpdateVisitRemarks] = useState(false)
  const [triggerTabId, setTriggerTabId] = useState('')
  const tabId = getTabId()
  const isUpcoming = tableView === 'Upcoming'
  const sideBarRef = useRef(null)
  const searchTitle = useRef('')
  const { visitsList, totalCount } = visits || {}

  const refreshVisits = useCallback(() => {
    const { fromDate, toDate } = stateFilter.date
    const visitParams = {
      fromDate,
      toDate,
      visitsType: tableView,
      Offset: paginationState[0],
      Count: COUNT_STEP,
      searchValue: visitSearchValue,
      visitTypesFilterRow,
      statusFilterRow,
      tagFilterRow,
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getVisits(visitParams))
  }, [
    dispatch,
    paginationState,
    stateFilter.date,
    statusFilterRow,
    tableView,
    visitSearchValue,
    visitTypesFilterRow,
    tagFilterRow,
  ])
  const closeRemarks = useCallback(() => setShowRemarks(false), [])

  useEffect(() => {
    if (visitData && triggerTabId === tabId) {
      const { Status, VisitId, PatientId } = visitData || {}
      const isLinkToCalendar = UPCOMING_VISIT.includes(Status)
      const isLinkToPastVisit = PAST_VISIT.includes(Status)
      let link = ''

      if (isLinkToCalendar) {
        onHandleLinkToVisit({ PatientId, VisitId })
        link = `${PATIENT_UPCOMING_VISIT_PAGE_PATH}?ref=${EventLocations.visits}`
      }

      if (isLinkToPastVisit) {
        onHandleLinkToVisit({ PatientId, VisitId })
        link = `${PATIENT_PAST_VISIT_PAGE_PATH}?ref=${EventLocations.visits}`

        if (isUpcoming) {
          closeRemarks()
          refreshVisits()
        }
      }
      if (link) {
        window.open(link, ...windowOpenArgs)
      }
      dispatch(clearVisitData())
      setTriggerTabId('')
    }
  }, [visitData])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onPagination = (forward) => {
    setPaginationState((prev) => {
      // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
      const isValid = forward ? prev[0] + COUNT_STEP < totalCount && prev[1] !== totalCount : prev[0] - COUNT_STEP >= 0

      if (isValid) {
        return isValid && forward ?
            // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
            [prev[0] + COUNT_STEP, prev[1] + COUNT_STEP, true]
            // @ts-expect-error TS2362 -- MIGRATION: not approved, fix when encountered
          : [prev[0] - COUNT_STEP, prev[1] - COUNT_STEP, true]
      }

      return prev
    })
  }

  const paginationLeft = () => onPagination(false)
  const paginationRight = () => onPagination(true)

  const onClickRemarksIcon = useCallback(
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    ({ target }) => {
      const visitId = target.dataset?.id

      if (!showRemarks) {
        setShowRemarks(true)
      }

      setOpenedRemarksVisitId(visitId)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getRemarks(visitId))
    },
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    [dispatch, visitRemarks?.remarksList, showRemarks],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetTableView = (newTableView) => {
    removeStoredSelectedStatusList()
    removeStoredSelectedTagList()
    setStatusFilterRow('')
    setTableView(newTableView)
  }

  useEffect(() => {
    window.onpopstate = null
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (sideBarRef?.current?.isSideBarCollapsed()) {
      setExtraWidthClass(true)
    } else {
      setExtraWidthClass(false)
    }
    removeStoredSelectedVisitsList()
    removeStoredSelectedStatusList()
    removeStoredSelectedTagList()
  }, [])

  useEffect(() => {
    if (openedRemarksVisitId && remarks?.[openedRemarksVisitId]) {
      setVisitRemarks(remarks?.[openedRemarksVisitId])
    }
  }, [remarks, openedRemarksVisitId])

  useEffect(() => {
    removeStoredSelectedStatusList()
    removeStoredSelectedTagList()
  }, [tableView])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(setVisitError(''))
      }, 3500)
    }
  }, [error])

  useEffect(() => {
    if (stateFilter.error) {
      setTimeout(() => {
        dispatchFilter({ type: 'error', payload: '' })
      }, 3500)
    }
  }, [stateFilter.error])

  useEffect(() => {
    if (visitRemarksIsUpdated && isNeedToUpdateVisitRemarks) {
      setIsNeedToUpdateVisitRemarks(false)
      dispatch(resetRemarksUpdated())
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getRemarks(visitRemarks.visitId))
    }
  }, [visitRemarksIsUpdated, isNeedToUpdateVisitRemarks])

  useEffect(() => {
    const { fromDate, toDate } = stateFilter.date
    if (!isFirstRender && paginationState[2]) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        getVisits({
          fromDate,
          toDate,
          visitsType: tableView,
          Offset: paginationState[0],
          Count: COUNT_STEP,
          searchValue: visitSearchValue,
          visitTypesFilterRow,
          statusFilterRow,
          tagFilterRow,
        }),
      )
    }

    searchTitle.current = visitSearchValue || ''
  }, [paginationState])

  useEffect(() => {
    const { fromDate, toDate } = stateFilter.date
    setPaginationState(PAGINATION_INITIAL)
    if (tableView) {
      const options = {
        visitsType: tableView,
        fromDate,
        toDate,
        searchValue: visitSearchValue,
        Offset: PAGINATION_INITIAL[0],
        Count: COUNT_STEP,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }
      searchTitle.current = visitSearchValue || ''
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getVisits(options))
      setIsFirstRender(false)
    }
  }, [tableView, currentDate, visitTypesFilterRow, tagFilterRow, statusFilterRow, stateFilter.date])

  const onNextDayClick = useCallback(() => {
    closeRemarks()
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setCurrentDate((prev) => moment(prev).add(1, 'days'))
  }, [])

  const onPrevDayClick = useCallback(() => {
    closeRemarks()
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setCurrentDate((prev) => moment(prev).subtract(1, 'days'))
  }, [])

  useEffect(() => {
    if (visitSearchValue.length >= 3) {
      const { fromDate, toDate } = stateFilter.date
      setPaginationState(PAGINATION_INITIAL)
      const options = {
        visitsType: tableView,
        fromDate,
        toDate,
        searchValue: visitSearchValue,
        Offset: PAGINATION_INITIAL[0],
        Count: COUNT_STEP,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }

      searchTitle.current = visitSearchValue || ''
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getVisits(options))
    }
  }, [])
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeSearchInput = (value) => {
    const searchValue = value.trim()
    if ((visitSearchValue.length && searchValue === '') || searchValue.length >= 3) {
      const { fromDate, toDate } = stateFilter.date
      setPaginationState(PAGINATION_INITIAL)
      const options = {
        visitsType: tableView,
        fromDate,
        toDate,
        searchValue,
        Offset: PAGINATION_INITIAL[0],
        Count: COUNT_STEP,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }

      searchTitle.current = searchValue || ''
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getVisits(options))
      setVisitSearchValue(searchValue)
    }
  }

  const onSearch = debounce(onChangeSearchInput, 500)

  let noResults = ''
  if (loading) {
    noResults = ''
  } else if (
    visitSearchValue ||
    visitTypesFilterRow ||
    statusFilterRow ||
    tagFilterRow ||
    stateFilter.date.isDateUpdated
  ) {
    noResults = 'No visits to display'
  } else {
    noResults = 'No visits for this day to display'
  }

  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const hideLeftPaginationArrow = paginationState[0] + 1 <= 1
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const hideRightPaginationArrow = paginationState[0] + COUNT_STEP >= totalCount

  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const leftPaginationCount = paginationState[0] + 1
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const rightPaginationCount = paginationState[1] > totalCount ? totalCount : paginationState[1]

  const paginationCounts = {
    left: leftPaginationCount,
    right: rightPaginationCount,
  }

  const paginationScore =
    totalCount !== 1 ?
      `${paginationCounts.left}-${paginationCounts.right} of ${totalCount}`
    : `${paginationCounts.right} of ${totalCount}`

  const hidePaginationArrowsSection = totalCount <= COUNT_STEP

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const reloadSection = () => {
    const { fromDate, toDate } = stateFilter.date
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      getVisits({
        fromDate,
        toDate,
        visitsType: tableView,
        Offset: paginationState[0],
        Count: COUNT_STEP,
        searchValue: visitSearchValue,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }),
    )
  }

  const visitsBodyTableStyle = {
    minHeight: 76,
    borderBottom: visitsList?.length ? 'none' : '1px solid #c2d5e2',
  }

  return (
    <>
      {loading || visitTypesLoading ?
        <PageLoadingSpinner />
      : null}

      <VisitsListener
        setIsNeedToResetRemarksInputError={setIsNeedToResetRemarksInputError}
        setIsNeedToUpdateVisitRemarks={setIsNeedToUpdateVisitRemarks}
        refreshVisits={refreshVisits}
      />
      <PageLayout>
        <div className='visits-page-container'>
          {error || stateFilter.error ?
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            <div style={errorAlertStyle}>
              <ErrorAlert
                styleContainer={errorAlertContainerStyle}
                errorText={error || stateFilter.error}
                errorImg={errorIcon}
                imgAlt='Error'
              />
            </div>
          : null}
          <div
            className={
              extraWidthClass ?
                noTransition ?
                  'visits-page-title-block visits-page-title-block-extra no-transition'
                : 'visits-page-title-block visits-page-title-block-extra'
              : noTransition ?
                'visits-page-title-block notransition'
              : 'visits-page-title-block'
            }>
            <div className='visits-page-title'>Visits</div>
            <div className='visit-page-tools'>
              <div className='visit-page-search-section'>
                <Search isWithoutSearchDropdown onInputChange={onSearch} />
              </div>
              <VisitsPageTools
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                onNextDayClick={onNextDayClick}
                onPrevDayClick={onPrevDayClick}
                setCurrentDate={setCurrentDate}
                setTableView={onSetTableView}
                tableView={tableView}
                currentDate={currentDate}
                onSelectCalendarCallback={closeRemarks}
                onSelectDropdownCallback={closeRemarks}
              />
            </div>
          </div>
          <div className='visits-page-table-container' />

          <div
            className={classNames('table-container', {
              'extra-table-container': extraWidthClass,
              'is-with-border': !!visitsList?.length,
            })}>
            <div className='visitRemarksContainer'>
              {showRemarks ?
                <VisitRemarks
                  remarks={visitRemarks}
                  loading={loading}
                  close={closeRemarks}
                  isNeedToResetRemarksInputError={isNeedToResetRemarksInputError}
                  setIsNeedToResetRemarksInputError={setIsNeedToResetRemarksInputError}
                />
              : null}

              <VisitTableColumnTitles
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                setVisitTypesFilterRow={setVisitTypesFilterRow}
                setStatusFilterRow={setStatusFilterRow}
                visitTypesFilterRow={visitTypesFilterRow}
                statusFilterRow={statusFilterRow}
                tagFilterRow={tagFilterRow}
                setTagFilterRow={setTagFilterRow}
                closeRemarks={closeRemarks}
                tableView={tableView}
                visitsList={visitsList}
                stateFilter={stateFilter}
                dispatchFilter={dispatchFilter}
                type={isUpcoming ? 'upcomingCollapsed' : 'pastCollapsed'}
              />
              <div
                className={classNames('visits-page-body-table', {
                  'visits-page-body-table-100': visitsList?.length,
                })}
                style={visitsBodyTableStyle}
                id='visits-page-body-table'>
                {visitsList?.length && !loading ?
                  visitsList?.map(
                    (
                      {
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        VisitDateTime,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        ServiceTypeName,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        VisitTypeName,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        Method,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        Patient,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        Status,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        VisitId,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        VisitNumber,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        IsNewForPatient,
                        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                        IsNewForServiceType,
                      },
                      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                      i,
                    ) => (
                      <VisitTableColumnRows
                        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                        setTriggerTabId={setTriggerTabId}
                        key={VisitId}
                        id={i + 1}
                        type={isUpcoming ? 'upcomingCollapsed' : 'pastCollapsed'}
                        Date={VisitDateTime}
                        Service={ServiceTypeName}
                        VisitMethod={Method}
                        VisitTypeName={VisitTypeName}
                        Patient={Patient}
                        VisitId={VisitId}
                        VisitNumber={VisitNumber}
                        Remarks={<RemarksIcon onClick={onClickRemarksIcon} VisitId={VisitId} />}
                        PatientId={Patient.PatientId}
                        Status={Status}
                        index={i}
                        IsNewForPatient={IsNewForPatient}
                        IsNewForServiceType={IsNewForServiceType}
                        isUpcoming={isUpcoming}
                        timeZone={timeZone}
                        isLast={i === visitsList.length - 1}
                      />
                    ),
                  )
                : <div className='visits-page-body-empty-table'>{noResults}</div>}
              </div>
            </div>
          </div>
          {!loading && visitsList?.length ?
            <footer
              className={classNames('visits-pagination-container', {
                'hide-visits-pagination-actions': hidePaginationArrowsSection,
                'extra-pagination-container': extraWidthClass,
              })}>
              <section className='visits-pagination-counter'>
                <span>{paginationScore}</span>
              </section>
              <section className='visits-pagination-actions'>
                <SvgIcon
                  className={classNames('visits-pagination-icon-left', {
                    'visits-pagination-icon-hidden': hideLeftPaginationArrow,
                  })}
                  name='chevronDown'
                  onClick={paginationLeft}
                />
                <SvgIcon
                  className={classNames('visits-pagination-icon-right', {
                    'visits-pagination-icon-hidden': hideRightPaginationArrow,
                  })}
                  name='chevronDown'
                  onClick={paginationRight}
                />
              </section>
            </footer>
          : null}
        </div>
      </PageLayout>
    </>
  )
}
